<div class="loading-component">
  <mat-spinner [diameter]="data.spinnerDiameter"></mat-spinner>
  <div class="vertical-flex-center">{{ data.loadingText }}</div>
</div>
